import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sortButton: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.sort-button.sort-button',
		defaultMessage: 'Sort the issues by this column',
		description: 'This desciption shows the significance of the sort button.',
	},
});
